// extracted by mini-css-extract-plugin
export var deleteModal = "_jg-0";